import { UnionSmallIcon } from "@/assets/images/svgIcons/unionSmallIcon"
import { Button } from "@/components/ui/baseUi/button"
import Vector from "@images/background/vector.svg"
import CongratCard from "@images/box/congratCard.svg"
import { SmallArrowIcon } from "@images/svgIcons/arrowIcon"
import { BoxOnboardingWrapper } from "@modules/box/components/boxOnboardingWrapper"
import { word } from "@modules/core/utils/i18n"
import { Path } from "@modules/navigation/routes"
import { useNavigate } from "react-router"
import { Text } from "@/components/ui/baseUi/text"

/**
 * This page is used when the owner has successfully registered on Stripe
 * Stripe calls this page as a callback
 * @returns {React.ReactNode} - Wrapper & Header & content & button
 */
export const BoxOnboardingStripeReturn: React.FC = () => {
  const navigate = useNavigate()
  const handleClose = () => {
    navigate(Path.Box.Admin)
  }

  return (
    <BoxOnboardingWrapper backgroundImage={Vector} handleClose={handleClose}>
      <div className="flex w-full flex-col gap-10 p-12">
        {/* HEARDER */}
        <div className="flex w-full flex-col items-center gap-2">
          <UnionSmallIcon color="currentColor" />

          <Text fontStyle="HL" className="mt-5">
            {word("box.stripe.onboarding.return.title")}
          </Text>
          <Text fontStyle="BL">{word("box.stripe.onboarding.return.subtitle1")}</Text>
          <Text fontStyle="BL">{word("box.stripe.onboarding.return.subtitle2")}</Text>
          {/* <Text fontStyle="BL" color={theme.mainWhite}>
            {word("box.stripe.onboarding.return.subtitle3")}
          </Text> */}
        </div>

        {/* CONTENT */}
        <div className="mt-7 mb-8 flex justify-center gap-3">
          <img src={CongratCard} alt="OnboardingBoxStripe" width={180} height={180} />
        </div>

        {/* BUTTON */}
        <div className="flex flex-col items-center">
          <Button variant="primary" size="lg" onClick={() => handleClose()}>
            {word("box.stripe.onboarding.return.button")}
            <SmallArrowIcon color="var(--color-white)" width={14} height={14} />
          </Button>
        </div>
      </div>
    </BoxOnboardingWrapper>
  )
}
